// Раскрывающийся пункт меню

const menuSelector = ".js-menu";
const controlClass = "js-menu-control";
const expandedClass = "menu__item--expanded";
const closingClass = "menu__item--closed";

function init() {
    document.querySelector(menuSelector).addEventListener("click", toggle);
}

function toggle(e) {
    if (
        !e.target.classList.contains(controlClass) &&
        !e.target.parentNode.classList.contains(controlClass)
    ) {
        return;
    }
    e.currentTarget.classList.toggle(expandedClass);
    if (isOpening(e)) {
        onOpen(e.currentTarget);
    } else {
        onClose(e.currentTarget);
    }
}

function onClose(el) {
    el.classList.add(closingClass);
    document.removeEventListener("click", clickOutside);
}

function onOpen(el) {
    el.classList.remove(closingClass);
    document.addEventListener("click", clickOutside);
}

function isOpening(e) {
    return e.currentTarget.classList.contains(expandedClass);
}

function clickOutside(e) {
    const openedMenu = document.querySelector("." + expandedClass);
    if (!openedMenu) {
        return;
    }
    const withinBoundaries = e.composedPath().includes(openedMenu);
    if (!withinBoundaries) {
        openedMenu.classList.toggle(expandedClass);
        onClose(openedMenu);
    }
}

init();

export default {};
